const TONES = {
  neutral: 'bg-surface-3 text-ink-2',
  brand: 'bg-brand-600 text-white',
  soft: 'bg-brand-soft text-accent',
};

/** Small numeric pill: unread counters on rows and tab counts. */
export default function CountBadge({ value, tone = 'neutral', className = '' }) {
  if (value === 0 && tone !== 'neutral') return null;

  return (
    <span
      className={`inline-flex min-w-[20px] items-center justify-center rounded-full px-1.5 py-0.5 text-[11px] leading-none font-semibold tabular-nums ${TONES[tone]} ${className}`}
    >
      {value > 99 ? '99+' : value}
    </span>
  );
}
